import React, { useRef, useEffect, useState } from "react";
import { LuFolder, LuFolderOpen } from "react-icons/lu";
import { TbFile, TbTrash } from "react-icons/tb";

const CodeTree = ({
    treeData,
    activeTab,
    selectedFilePath,
    setSelectedFilePath,
    openFolders,
    setOpenFolders,
    renamingNode,
    setRenamingNode,
    setDeletingNode,
    setOpenDeletingModal,
    handleFileClick,
    setCodebase,
}) => {
    const renamingInputRef = useRef(null);

    const getNodeByPath = (tree, path) => {
        if (!path) return tree;
        const parts = path.split("/");
        let current = tree;
        for (let part of parts) {
            if (!current[part]) return null;
            current = current[part];
        }
        return current;
    };

    const toggleFolder = (path) => {
        setOpenFolders((prev) => ({ ...prev, [path]: !prev[path] }));
    };

    const renderTree = (node, path = "", level = 0) => {
        return Object.entries(node).map(([name, value]) => {
            const currentPath = path ? `${path}/${name}` : name;
            const isSelected = currentPath === selectedFilePath;
            const isOpen = openFolders[currentPath];
            const isRenaming = renamingNode.path === currentPath;

            const isFileObject = value && typeof value === "object" && value.hasOwnProperty("filename");

            if (isFileObject) {
                return (
                    <div
                        key={currentPath}
                        style={{
                            marginLeft: level * 10,
                            cursor: "pointer",
                            background: isSelected ? "var(--lightGrey)" : "transparent",
                            padding: "2px 5px",
                            borderRadius: 5,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                        onClick={() => handleFileClick(currentPath, value)}
                    >
                        {isRenaming ? (
                            <input
                                ref={renamingInputRef}
                                className="new_tree_item_input"
                                autoFocus
                                value={renamingNode.name}
                                onChange={(e) => setRenamingNode((prev) => ({ ...prev, name: e.target.value }))}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && renamingNode.name.trim()) {
                                        setCodebase((prev) => {
                                            const newCodebase = { ...prev };
                                            const parts = currentPath.split("/");
                                            const oldName = parts.pop();
                                            const parentPath = parts.join("/");
                                            const parentNode = getNodeByPath(newCodebase[activeTab], parentPath);
                                            if (parentNode) {
                                                parentNode[renamingNode.name] = parentNode[oldName];
                                                delete parentNode[oldName];
                                            }
                                            return newCodebase;
                                        });
                                        setRenamingNode({ path: null, name: "" });
                                    }
                                    if (e.key === "Escape") setRenamingNode({ path: null, name: "" });
                                }}
                                style={{ marginLeft: 5, width: 150 }}
                            />
                        ) : (
                            <>
                                <span className="tree_filename" title={value.filename}>
                                    <TbFile /> {value.filename}
                                </span>
                                <span className="delete_file_folder_btn" style={{ display: "flex", alignItems: "center" }}>
                                    <TbTrash
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setDeletingNode({ path: currentPath, name });
                                            setOpenDeletingModal(true);
                                        }}
                                    />
                                </span>
                            </>
                        )}
                    </div>
                );
            }

            if (typeof value === "object") {
                return (
                    <div key={currentPath}>
                        <div
                            onClick={() => toggleFolder(currentPath)}
                            style={{
                                marginLeft: level * 10,
                                cursor: "pointer",
                                fontWeight: "bold",
                                background: isSelected ? "var(--lightGrey)" : "transparent",
                                padding: "2px 5px",
                                borderRadius: 5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <span className="tree_filename">
                                {isOpen ? <LuFolderOpen style={{ marginRight: 5 }} /> : <LuFolder style={{ marginRight: 5 }} />}
                                {name === "frontend" || name === "backend"
                                    ? name.charAt(0).toUpperCase() + name.slice(1)
                                    : name}
                            </span>

                            <span className="delete_file_folder_btn" style={{ display: "flex", alignItems: "center" }}>
                                <TbTrash
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setDeletingNode({ path: currentPath, name });
                                        setOpenDeletingModal(true);
                                    }}
                                />
                            </span>
                        </div>

                        {isRenaming && (
                            <div style={{ marginLeft: (level + 1) * 10, display: "flex", alignItems: "center" }}>
                                <input
                                    ref={renamingInputRef}
                                    className="new_tree_item_input"
                                    autoFocus
                                    value={renamingNode.name}
                                    onChange={(e) => setRenamingNode((prev) => ({ ...prev, name: e.target.value }))}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" && renamingNode.name.trim()) {
                                            setCodebase((prev) => {
                                                const newCodebase = { ...prev };
                                                const parts = currentPath.split("/");
                                                const oldName = parts.pop();
                                                const parentPath = parts.join("/");
                                                const parentNode = getNodeByPath(newCodebase[activeTab], parentPath);
                                                if (parentNode) {
                                                    parentNode[renamingNode.name] = parentNode[oldName];
                                                    delete parentNode[oldName];
                                                }
                                                return newCodebase;
                                            });
                                            setRenamingNode({ path: null, name: "" });
                                        }
                                        if (e.key === "Escape") setRenamingNode({ path: null, name: "" });
                                    }}
                                    style={{ marginLeft: 5, width: 150 }}
                                />
                            </div>
                        )}

                        {isOpen && renderTree(value, currentPath, level + 1)}
                    </div>
                );
            }
        });
    };

    return <>{renderTree(treeData)}</>;
};

export default CodeTree;
